import { FunctionComponent } from 'react';
import { match } from 'react-router-dom';

import { renderRoutes } from 'scenes/Report/Report.helper';

import { SafegraphVisitorShare, SafegraphLapsedUser } from '.';

type Props = {
  match: match;
  whitelistReports?: string[];
};

const routes = (match: match) => [
  { path: `${match.url}/safegraphLapsedUser`, component: SafegraphLapsedUser },
  {
    path: `${match.url}/safegraphVisitorShare`,
    component: SafegraphVisitorShare,
  },
];

const ThirdPartyReportsRoutes: FunctionComponent<Props> = ({
  match,
  whitelistReports,
}) => renderRoutes(routes(match), whitelistReports);

export default ThirdPartyReportsRoutes;
